<div class="body">

    <div class="headline">
        {{contract.contractnumber}} {{contract.contractdesc}}
    </div>

</div>